import {postLogoutRedirectUri,msalConfig } from '../../config/msalConfig';

export  function azureLogOut(msalInstance) {
    if(window.sessionStorage.getItem('home_account')){
      const currentAccount =  msalInstance.getAccountByHomeId(JSON.parse(window.sessionStorage.getItem('home_account'))?.homeAccountId);	
        msalInstance.logoutRedirect({	
        account: currentAccount,	
        postLogoutRedirectUri: postLogoutRedirectUri.redirectUri,	
        authority: msalConfig.auth.authority	
      });	
    }else{
        msalInstance.logoutRedirect({	
        postLogoutRedirectUri: postLogoutRedirectUri.redirectUri,	
        authority: msalConfig.auth.authority	
      });	
    }
    window.sessionStorage.clear();
    window.localStorage.clear();
    window.sessionStorage.setItem('isLogout',true);
    window.localStorage.setItem('isLogout',true);
  }
